import { composables } from "@orange-marmalade/paginate-this";

export default function search(listId, searchApi, stateLocator) {
  const pageActions = composables({ listId });
  const defaultStateLocator = state => state[listId];

  return {
    search: pageInfo => () => searchApi(pageInfo.query),
    setFilter: (k, v) => pageActions.setFilter(k, v),
    setFilters: filters => pageActions.setFilters(filters),
    setLimit: size => pageActions.setPageSize(size),
    setPage: page => pageActions.goTo(parseInt(page, 10)),
    stateLocator: stateLocator || defaultStateLocator,
    pageActions,
    listId
  };
}



// WEBPACK FOOTER //
// ./app/modules/shared/actions/search.js